<template>
  <form @submit.prevent="vLaunchOrderDetailResearch">
    <div class="order-research">
      <div class="form-field">
        <label>{{$_('satab_product_reference')}} *</label>
        <SelectAutocomplete
          delay="300"
          :itemoption="['TMOD', 'TMOD']"
          @autocomplete:selected="vSelectedStore('detail_fmod', $event.TMOD)"
          :ajax="true"
          :func="vSearchProduct"
        />
      </div>
      <div class="form-field">
        <label>{{$_('size')}}*</label>
        <Select 
          :itemoption="['TTAILLE', 'TTAILLE']"
          @select-change="vSelectedStore('detail_ftail', $event.item)"
          :search="true"
          :data="search_data.size"
        />   
      </div>
      <div class="form-field">
        <label>{{$_('color')}}*</label>
        <SelectAutocomplete
          :itemoption="['TCOL', 'TCOL']"
          @autocomplete:selected="vSelectedStore('detail_fcol', $event.TCOL)"
          :ajax="true"
          :func="vSearchColor"
        />
      </div>
      <div class="form-field">
        <label>{{$_('customer_product_reference')}}*</label>
        <Select 
          :placeholder="$_('customer_product_reference')" 
          :itemoption="['TREFC', 'TREFC']"
          @select-change="vSelectedStore('detail_fref', $event.item)"
          :search="true"
          :data="search_data.customer"
        />   
      </div> 
      <div class="form-field btn-launch-container">
        <button class="btn">{{$_('research_button')}}</button>
      </div>
    </div>
  </form>
</template>

<script>
import Select from "@/common/components/widget/Select";
import SelectAutocomplete from "@/common/components/widget/Autocomplete/SelectAutocomplete";
import orderService from '@/modules/commande/services/orderService.js';

export default {
  data() {
    return {
      search_data: {
        colors: Array(),
        status: [
          {TSTATUT: '000', TLIB_STATUT: this.$_('sale')},
          {TSTATUT: '001', TLIB_STATUT: this.$_('deleted')},
          {TSTATUT: '111', TLIB_STATUT: this.$_('in_progress')}
        ],
        product: Array(),
        customer: Array(),
        size: Array()
      }
    }
  },
  components: {
    Select,
    SelectAutocomplete
  },
  created() {
    this.vSearchRefCustomer();
    this.vSearchSize();
  },
  methods: {
    vLaunchOrderDetailResearch() {
      this.$store.dispatch('commande/LAUNCH_DETAIL_RESEARCH', {launch_detail_research: true});
    },
    vSelectedStore(key, value) {
      this.$store.dispatch('commande/SELECT', {key, value});
    },
    vSearchProduct(query) {
      return orderService.getProduct(query, this.$route.params.order_id).then(res => {
        if(res.data.DS_O.OUT !== undefined) {
          return res.data.DS_O.OUT
        }
      })
    },
    vSearchColor(query) {
      return orderService.getOrderColor(query, this.$route.params.order_id).then(res => {
        if(res.data.DS_O.OUT !== undefined) {
          return res.data.DS_O.OUT
        }
      })
    },
    vSearchRefCustomer() {
      return orderService.getRefCustomer(this.$route.params.order_id).then(res => {
       if(res.data.DS_O !== undefined) {
          res.data.DS_O.OUT.map(obj => {
            this.search_data.customer.push(obj);
          });
        }
      })
    },
    vSearchSize() {
      return orderService.getSize(this.$route.params.order_id).then(res => {
        if(res.data.DS_O !== undefined) {
          res.data.DS_O.OUT.map(obj => {
            this.search_data.size.push(obj);
          });
        }
      })
    }
  }
};
</script>

<style scoped>
.order-research {
  background-color: #f5f5f5;
  padding: 20px;
  display: flex;
  flex-wrap: wrap
}
form {
  width: 1;
}
.form-field {
  margin: 5px;
}
label {
  padding-left: 20px;
}
.form-element {
  width: 200px;
}
/deep/
.select-box {
  margin: 0px;
}
.btn-launch-container {
  display: flex;
  justify-content: flex-end;
}
</style>